import React, { ReactElement, memo } from 'react';
import { StepConfig } from '../../utils/types';
import './Stepper.css';

interface Props {
  stepConfig: StepConfig[];
  currentRoute: string;
  navigateTo?: any;
}

const Stepper: React.FC<Props> = ({ stepConfig, currentRoute, navigateTo }) => {
  const canNavigateToStep = (step: StepConfig): boolean =>
    Boolean(navigateTo) && Boolean(step.completed || step.hasError);

  const getStepClassName = (step: StepConfig): string => {
    let returnValue: string = 'step-item';
    if (step.hasError) {
      returnValue += ' step-border-error';
    } else if (step.completed) {
      returnValue += ' step-border-completed';
    } else if (currentRoute === step.route || currentRoute === 'sign') {
      returnValue += ' step-border-current';
    }
    if (step?.trackDate) {
      returnValue += ' step-item-date';
    }
    return returnValue;
  };

  const getStepIcon = (step: StepConfig): ReactElement => {
    if (currentRoute === step.route || (currentRoute === 'sign' && step.route === 'review')) {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2Z"
            fill="#5D970C"
          />
        </svg>
      );
    } else if (step.hasError) {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM11 7H13V13H11V7ZM11 15H13V17H11V15Z"
            fill="#BF3B2A"
          />
        </svg>
      );
    } else if (step.completed) {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.419 20 12C20 7.581 16.419 4 12 4ZM11 16.5L6.5 12L7.91 10.59L11 13.67L16.59 8.08996L18 9.49996L11 16.5Z"
            fill="#5D970C"
          />
        </svg>
      );
    } else {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.419 20 12C20 7.581 16.419 4 12 4Z"
            fill="#6B6E6F"
          />
        </svg>
      );
    }
  };

  return (
    <div className="stepper-wrap">
      {stepConfig.map((step: StepConfig) => (
        <button
          key={step.route}
          className={getStepClassName(step)}
          onClick={() => {
            if (canNavigateToStep(step)) {
              navigateTo(step.route);
            }
          }}
          type="button"
        >
          {getStepIcon(step)}
          <div>
            <p>{step.name}</p>
            {step?.trackDate && <p>{step?.trackDate}</p>}
          </div>
        </button>
      ))}
    </div>
  );
};

Stepper.displayName = 'Stepper';
export default memo(Stepper);
